import { observer } from "mobx-react";
import React from "react";
import MenuItem from "@material-ui/core/MenuItem";
import { Secured } from "../Secured";
import { RelativeLink } from "../RelativeLink/RelativeLink";
import { Theme, WithStyles } from "@material-ui/core";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";

export const linkButtonStyles = (theme: Theme) =>
  createStyles({
    menuItem: {
      width: "100%"
    },
    title: {
      float: "left",
      marginRight: 5,
      marginTop: 3
    },
    icon: {
      float: "right"
    }
  });

export interface SecuredMenuButtonProps
  extends WithStyles<typeof linkButtonStyles> {
  children: React.ReactElement;
  link: string;
  title: string;
  requiredAccess: string;
}

@observer
export class SecuredMenuLinkButtonComponent extends React.Component<
  SecuredMenuButtonProps
> {
  public render() {
    const { classes } = this.props;

    return (
      <Secured
        requiredAccess={this.props.requiredAccess}
        key={this.props.title.toLowerCase()}
      >
        <RelativeLink to={this.props.link}>
          <MenuItem>
            <div className={classes.menuItem}>
              <div className={classes.title}>{this.props.title}</div>
              <div className={classes.icon}>{this.props.children}</div>
            </div>
          </MenuItem>
        </RelativeLink>
      </Secured>
    );
  }
}

export const SecuredMenuLinkButton = withStyles(linkButtonStyles, {
  withTheme: true
})(SecuredMenuLinkButtonComponent);
